export const DELETE_SPOT_LIST_SUCCESS = 'DELETE_SPOT_LIST_SUCCESS';

export const deleteSpotListSuccess = ( id: string ) => ({
    type: DELETE_SPOT_LIST_SUCCESS,
    payload: {
        id,
    },
});
